import { Controller } from '@hotwired/stimulus';
import { MDCRadio } from '@material/radio';

export default class extends Controller {
  static targets = ['associatedUnits', 'yesRadio', 'noRadio'];

  connect() {
    this.initRadios();
    this.sync();
  }

  // Initialize the MDC radio components
  initRadios() {
    this.yes?.destroy?.();
    this.no?.destroy?.();

    if (this.hasYesRadioTarget) this.yes = new MDCRadio(this.yesRadioTarget);

    if (this.hasNoRadioTarget) this.no = new MDCRadio(this.noRadioTarget);
  }

  // Keep DOM and MDC in sync on page load
  sync() {
    const selected = this.element.querySelector(
      'input[name*="[associated_with_all_units]"]:checked'
    );
    const val = (selected?.value ?? '').toLowerCase();
    const isNo = val === '0' || val === 'false';

    if (isNo) {
      this.showUnits();
    } else {
      this.hideUnits();
    }
  }

  // Handlers from radio data-actions
  showUnits() {
    this.associatedUnitsTarget.classList.remove('hidden');
  }

  hideUnits() {
    this.associatedUnitsTarget.classList.add('hidden');
  }
}
